/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { Component, ContentChildren, EventEmitter, Input, Output, QueryList } from '@angular/core';
import { ButtonComponent } from '../../button/button.component';
import { FormListItemComponent } from './form-list-item/form-list-item.component';

@Component({
  selector: 'ods-form-list',
  imports: [ButtonComponent],
  host: { 'attr.role': 'list', class: 'flex flex-col gap-4' },
  template: `
    <ng-content />
    <ods-button
      [text]="addButtonLabel"
      icon="plus"
      (clicked)="onAddButtonClicked()"
      [dataTestId]="'add-' + dataTestId + '-button'"
      data-test-class="add-button"
    />
  `,
})
export class FormListComponent {
  @Input({ required: true }) addButtonLabel: string;
  @Input() dataTestId: string = '';

  @Output() addButtonClicked = new EventEmitter<void>();

  @ContentChildren(FormListItemComponent) items: QueryList<FormListItemComponent>;

  onAddButtonClicked(): void {
    this.addButtonClicked.emit();
    setTimeout(() => this.items.last.focus());
  }
}
